<script lang="ts">
  import { Contacts,Personal} from "../../../utils/Constant/Constant";
  import Card from "../../Core/Card.svelte";
  import PersonalContactMenu from "./PersonalContactMenu.svelte";
  import {contactMenuId,personalData} from "../../../store"
  import PersonalContactContent from "./PersonalContactContent.svelte";
  import { Row } from "sveltestrap";
  let setContactMenuId:string
  contactMenuId.subscribe((value)=>{
    setContactMenuId = value
  })
  let setPersonalData:any
  personalData.subscribe((value)=>{
      setPersonalData = value
  })
</script>
<div class="tab-pane {setContactMenuId === "personal-tab" ? "active show" : ""}" id="pills-personal">
    <Card cardProps="mb-0" cardHeaderprops="d-flex" cardBodyprops="p-0">
      <div slot="customheader" class="d-flex align-items-center justify-content-between w-100">
        <h5>{Personal}</h5>
        <span class="f-14 pull-right mt-0">{setPersonalData.length} {Contacts}</span>
      </div>
      <div slot="contentbody">
        <Row class="list-persons" id="addcon">
          <PersonalContactMenu />
          <PersonalContactContent />
        </Row>
      </div>
    </Card>
</div>